import { render, staticRenderFns } from "./HomeAoVivo.vue?vue&type=template&id=7588d223&"
import script from "./HomeAoVivo.vue?vue&type=script&lang=js&"
export * from "./HomeAoVivo.vue?vue&type=script&lang=js&"
import style0 from "./HomeAoVivo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports